import * as React from "react"

import { FlowQuestionId } from "types"
import * as styles from "./styles.module.scss"
import Button from "../../Button"
import heroLandscape_1920w from "./img/flow-refinance-hero-landscape-1920w.jpg"
import heroLandscape_960w from "./img/flow-refinance-hero-landscape-960w.jpg"
import heroPortrait_1080w from "./img/flow-refinance-hero-portrait-1080w.jpg"
import heroPortrait_540w from "./img/flow-refinance-hero-portrait-540w.jpg"
import Section from "../Section"

export interface StartProps {
  currentQuestionId: FlowQuestionId
  heading: string
  startCallback: () => void
  subhead: string
}

const Start: React.FC<StartProps> = ({
  currentQuestionId,
  heading,
  startCallback,
  subhead,
}) => {
  return (
    <Section
      className={styles.start}
      flowKey={FlowQuestionId.Start}
      currentId={currentQuestionId}
      dataJsPosition="in-viewport"
    >
      <div className={styles.pagePadding}>
        <div className={styles.pictureWrapper}>
          <picture className={styles.picture}>
            <source
              media="(orientation: landscape)"
              srcSet={`${heroLandscape_1920w} 1920w, ${heroLandscape_960w} 960w`}
              sizes="100vw"
            />
            <source
              media="(orientation: portrait)"
              srcSet={`${heroPortrait_1080w} 1080w, ${heroPortrait_540w} 540w`}
              sizes="100vw"
            />
            <img
              className={styles.image}
              src={heroLandscape_960w}
              alt="Is it time to refinance?"
            />
          </picture>
        </div>
        <div className={styles.message}>
          <div className={styles.header}>
            <h2 className={styles.heading}>{heading}</h2>
            <p className={styles.subhead}>{subhead}</p>
          </div>
          <div className={styles.button}>
            <Button
              type="primaryNeon"
              size="xxl"
              halo={true}
              data-qa="start-button"
              onClick={startCallback}
            >
              Start
            </Button>
          </div>
        </div>
      </div>
    </Section>
  )
}

export default Start
